export default "__VITE_ASSET__DQc_aodT__"